<template>
  <pt-all-customer class="pt-all-customer__page"></pt-all-customer>
</template>

<script>
import PtAllCustomer from 'cps/customer-manage/pt-all-customer/withData'
export default {
  name: 'pt-all-customer__view',
  components: {
    'pt-all-customer': PtAllCustomer
  }
}
</script>
